import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts } from '../actions/ProductActions.js';
import ProductCard from './ProductCard';
import { useNavigate } from 'react-router-dom';
// import { selectBestSellerProducts } from '../selectors/ProductSelector';
import { fetchFilteredProducts } from '../actions/FilterActions';
import '../styles/bestsellers.css';  
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { ProductCarouselSkeleton } from "./HomeSkeletons";
import axios from 'axios';
import { API_URL } from '../variables';
import { toast } from 'react-toastify';


const BestSellers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 30;
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // const bestSellerProducts = useSelector(selectBestSellerProducts);
  const scrollRef = useRef(null);

  // useEffect(() => {
  //   dispatch(fetchFilteredProducts({
  //     tags: ['BEST SELLER'],
  //     page: 1,
  //     status: 'published',
  //     pagination: 30,
  //   }));
  // }, [dispatch, currentPage]);

  const loadBestSellers = async () => {
    try {
      setLoading(true);
      const response = await axios.post(`${API_URL}/api/products/filter?page=${currentPage}`, {
        tags: ['BEST SELLER'],
        status: 'published',
        pagination: 30,
      });

      if (response.status === 200) {
        setFilteredProducts(response.data.results);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(response.data.message || 'Something went wrong.');
      }
    } catch (error) {
      setLoading(false);
      if (error.name === 'ZodError') {
        toast.error(error.errors[0].message);
      } else if (error.response) {
        toast.error(error.response.data.message || 'An error occurred. Please try again.');
      } else {
        toast.error('An error occurred. Please try again.');
      }
    }
  }

  useEffect(() => {
    loadBestSellers();
  }, [currentPage]);

  const handleProductClick = (product) => {
    navigate(`/product/${product.slug || product.product_id}`);
  };

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
  };

  if (loading)
    return (
      <ProductCarouselSkeleton title="Best Sellers" variant="bestsellers" />
    );
  if (error) return <div>Error: {error}</div>;

  if (filteredProducts && filteredProducts.length === 0) {
    return (
      <div className="bestsellers-section">
        <div className="bestsellers-title-and-chevron">
          <h3 className="bestsellers-title">Best Sellers</h3>
        </div>
        <div className="no-products-message">
          No best selling products available at the moment.
        </div>
      </div>
    );
  }

  return (
    <div className="bestsellers-section">
      <div className="bestsellers-title-and-chevron">
        <h3 className="bestsellers-title">Best Sellers</h3>
        <div className="bestsellers-chevrons">
          <button className="nav-arrow" onClick={scrollLeft}><FaChevronLeft /></button>
          <button className="nav-arrow" onClick={scrollRight}><FaChevronRight /></button>
        </div>
      </div>
     <div className="bestsellers-grid" ref={scrollRef}>
        {filteredProducts && filteredProducts.length > 0 && (
          filteredProducts.map((product) => (
            <div
              key={product.product_id}
              className="bestsellers-product-item"
              onClick={() => handleProductClick(product)}
          >
            <ProductCard product={product} preferredTag="BEST SELLER" />
          </div>
        ))
        )}
      </div>
    </div>
  );
};

export default BestSellers;
